import { JSX, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { UserRole } from 'src/apollo/generated/graphql'
import { useUser } from 'src/contexts/user-provider/use-user'
import { withCompany } from 'src/helpers/company-slug'
import { BasicRoutesEnum as BR } from 'src/routes/routes'

type RoleGuardProps = {
  allowedRoles: UserRole[]
  children: ReactNode
}

const RoleGuard = ({ allowedRoles, children }: RoleGuardProps): JSX.Element => {
  const { user } = useUser()

  const hasAccess = user.roles.some(role => allowedRoles.includes(role))

  if (!hasAccess) {
    return <Navigate to={withCompany(BR.OVERVIEW)} replace />
  }

  return <>{children}</>
}

export default RoleGuard
